import { validate } from "../../utils/validate"
// hack做法 后续改造可以统一抽缓存公共方法 且preview包是否还有存在的必要？？
export const cache = {
  get(key) {
    try {
      validate.String(key, "key")
      return JSON.parse(sessionStorage.getItem(key))
    } catch (e) {
      throw Error(e)
    }
  },
  set(key, value) {
    try {
      validate.String(key, "key")
      // if (!["string", "number", "boolean"].includes(typeof value)) {
      //   throw Error(
      //     `The value parameter type must be string or number or boolean, but the ${typeof value} type was obtained.`
      //   )
      // }
      sessionStorage.setItem(key, JSON.stringify(value))
      return true
    } catch (e) {
      throw Error(e)
    }
  },
  remove(key) {
    try {
      validate.String(key, "key")
      sessionStorage.removeItem(key)
      return true
    } catch (e) {
      throw Error(e)
    }
  },
  clear() {
    try {
      sessionStorage.clear()
      return true
    } catch (e) {
      throw Error(e)
    }
  },
} as CacheDSL
